import { render, staticRenderFns } from "./UpdateCompanyDetail.vue?vue&type=template&id=252c5fec&scoped=true"
import script from "./UpdateCompanyDetail.vue?vue&type=script&lang=js"
export * from "./UpdateCompanyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c5fec",
  null
  
)

export default component.exports